import React, {useEffect, useState} from 'react'
import Swal from 'sweetalert2'
import {list_Property} from './SuperAdminProperty_Api'
import {CircularProgress} from '@mui/material'
import {Link} from 'react-router-dom'
import {useNavigate} from 'react-router-dom'
import PaginationComponent from '../../PaginationComponent/Pagination'
import AddProperty from '../../property/Add_NewProperty'

interface propertyDataDataType {
  carpet_area: string
  current_rent: string
  property_address: string
  property_title: string
  property_type_name: string
  property_usage_type: string
  property_uuid: string
  role: string
  sub_unit_available: string
}
const SuperAdminPropertyHome = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [noDataFound, setNoDataFound] = useState<boolean>()
  const [propertyData, setPropertyData] = useState<propertyDataDataType[]>()
  const [dataLength, setDataLength] = useState<number>(0)
  const [showAddPropertyModal, setShowAddPropertyModal] = useState<boolean>()
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 20
  const pageCount = Math.ceil(dataLength / itemsPerPage)
  // function to get properties which are already added
  async function getProperty() {
    setLoading(true)
    try {
      const response = await list_Property(currentPage)
      if (response.status === 200) {
        if (response.data.data.length !== 0) {
          setNoDataFound(false)
          setPropertyData(response.data.data.property)
          setDataLength(response.data.data.totalProperties)
        } else {
          setNoDataFound(true)
        }
      } else {
        setNoDataFound(true)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.data.msg.charAt(0).toUpperCase() + response.data.msg.slice(1),
          text: response.data.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getProperty()
  }, [currentPage])
  // routing to tenant page with the following parameters
  const submitTenant = (
    account_role_json: any,
    property_title: string,
    property_usage_type: string,
    sub_unit_available: string,
    property_uuid: string
  ) => {
    navigate('/tenant', {
      state: {
        account_role_json: account_role_json,
        propertytitle: property_title,
        property_usage_type: property_usage_type,
        sub_unit_available: sub_unit_available,
        property_uuid: property_uuid,
      },
    })
  }
  // routing to property user page with the following parameters
  const SubmitPropertyUsers = (
    account_role_json: any,
    property_uuid: any,
    property_title: string,
    property_usage_type: string,
    property_id: any
  ) => {
    navigate(`/propertyUsers/${property_uuid}`, {
      state: {
        account_role_json: account_role_json,
        property_uuid: property_uuid,
        propertytitle: property_title,
        property_usage_type: property_usage_type,
        property_id: property_id,
      },
    })
  }

  // function for add new property button: change later copy paste from previous code
  function handleBackButtonClick() {
    setShowAddPropertyModal(false)
  }
  return showAddPropertyModal ? <AddProperty onBackButtonClick={handleBackButtonClick}/> : 
        <>
      {loading ? (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
      ) : (
        // {* End: loader*}
        // {* Begin: property page content*}
        <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
          <div className='d-flex flex-column flex-column-fluid'>
            {/* Begin: header for property page */}
            <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 px-5'>
              <div>
                {/* Begin: Heading */}
                <h1
                  className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center'
                >
                  Properties
                </h1>
                {/* End: Heading */}

                <p className='text-muted fw-semibold text-muted d-block fs-7'>
                 {dataLength && `Total properties: ${dataLength}`}
                </p>
              </div>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                {/* Begin: Add Property button  */}
                <button
                  onClick={() => setShowAddPropertyModal(!showAddPropertyModal)}
                  className='btn btn-sm fw-bold btn-primary'
                >
                  Add New Property
                </button>
                {/* {showAddPropertyModal && (
                  <>
                    <AddNewNewProperty
                      show={showAddPropertyModal}
                      handleClose={() => setShowAddPropertyModal(false)}
                      getProperty={() => getProperty()}
                      activeKYC={[]}
                    />
                  </>
                )} */}
                {/* End: Add Property button  */}
                {/* {!noDataFound && (
                  <div className=''>
                    {/* Begin: filter button  
                    <button
                      className='btn btn-sm btn-flex btn-light fw-bold bg-color-white'
                      data-kt-menu-trigger='click'
                      data-kt-menu-placement='bottom-end'
                      data-kt-menu-flip='top-end'
                    >
                      Filter
                    </button>
                    {/* <FilterDropdown data={apiData} setPropertyData={setPropertyData} /> 
                    {/* End: filter button 
                  </div>
                )} */}
              </div>
            </div>
            {/* End: header for property page */}
            {/* Begin: Table */}
            <div id='table div'>
              <div className='card mb-5 mb-xl-8'>
                <div className='card-body py-3'>
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      {!noDataFound && (
                        <thead>
                          <tr className='fw-bold text-muted'>
                            {/* <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value='1'
                                data-kt-check='true'
                                data-kt-check-target='.widget-9-check'
                              />
                            </div>
                          </th> */}
                            <th className='max-w-150px'>Property Name</th>
                            <th className='max-w-100px'>Details</th>
                            <th className='max-w-150px'>Address</th>
                            <th className='max-w-100px'>Rent</th>
                            <th className='max-w-50px'>Role</th>
                            <th className='max-w-100px'>Actions</th>
                          </tr>
                        </thead>
                      )}
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {noDataFound ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  No properties added
                                </span>
                              </span>
                            </td>
                          </tr>
                        ) : (
                          propertyData?.map((property, index: number) => {
                            return (
                              <tr key={index}>
                                {/* <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                  <input
                                    className='form-check-input widget-9-check'
                                    type='checkbox'
                                    value='1'
                                  />
                                </div>
                              </td> */}
                                <td className='max-w-150px'>
                                  <div className='d-flex align-items-center'>
                                    <div className='symbol symbol-45px me-3'>
                                      <span className='symbol symbol-50px me-2'>
                                        <span className='symbol-label bg-light-primary'>
                                          {/* {property.property_img_url ? (
                                            <div className='symbol symbol-50px'>
                                              <img
                                                src={property.property_img_url}
                                                alt='Property icon'
                                                style={{objectFit: 'cover'}}
                                              />
                                            </div>
                                          ) : ( */}
                                          <i className='bi bi-house-door fs-2x btn btn-active-color-primary'></i>
                                          {/* )} */}
                                        </span>
                                      </span>
                                    </div>
                                    <div className='d-flex justify-content-start flex-column'>
                                      <Link
                                        to={`/property/${property.property_uuid}/overview`}
                                        className='text-dark fw-bold text-hover-primary fs-6'
                                        title={
                                          property.property_title.charAt(0).toUpperCase() +
                                          property.property_title.slice(1)
                                        }
                                      >
                                        <div className='text-truncate max-w-150px'>
                                          {property.property_title.charAt(0).toUpperCase() +
                                            property.property_title.slice(1)}
                                        </div>
                                      </Link>
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {property.property_type_name}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className='max-w-100px'>
                                  <div className='d-flex justify-content-start flex-column'>
                                    <div
                                      className='text-truncate max-w-150px text-dark fw-bold text-hover-primary fs-6'
                                      title={property.carpet_area}
                                    >
                                      {property.carpet_area}
                                    </div>
                                    <span
                                      className='text-truncate max-w-150px text-muted fw-semibold text-muted d-block fs-7'
                                      title={property.property_usage_type}
                                    >
                                      {property.property_usage_type}
                                    </span>
                                  </div>
                                </td>
                                <td className='max-w-150px'>
                                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    {property.property_address.charAt(0).toUpperCase() +
                                      property.property_address.slice(1)}
                                  </span>
                                </td>
                                <td className='max-w-100px'>
                                  <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                    {`₹ ${property.current_rent}`}
                                  </span>
                                </td>
                                <td className='max-w-50px'>
                                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    {property.role}
                                  </span>
                                </td>
                                <td className='max-w-100px'>
                                  <div className='d-flex flex-shrink-0'>
                                    <Link
                                      to={`/property/${property.property_uuid}/overview`}
                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    >
                                      <i
                                        className='bi bi-eye-fill bi-4x fs-2'
                                        title='View Property'
                                      ></i>
                                    </Link>
                                    <button
                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      onClick={() =>
                                        submitTenant(
                                          'non-tenant',
                                          property.property_title,
                                          property.property_usage_type,
                                          property.sub_unit_available,
                                          property.property_uuid
                                        )
                                      }
                                    >
                                      <i
                                        className='bi bi-file-earmark-person fs-3'
                                        title='View Tenant(s)'
                                      ></i>
                                    </button>
                                    <button
                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      onClick={() =>
                                        SubmitPropertyUsers(
                                          'non-tenent',
                                          // property.account_role_json,
                                          property.property_uuid,
                                          property.property_title,
                                          property.property_usage_type,
                                          property.property_uuid
                                        )
                                      }
                                    >
                                      <i
                                        className='bi bi-people-fill fs-3'
                                        title='Property Users'
                                      ></i>
                                    </button>
                                    {/* <Link
                                      to={`/property/rent_info/${property.property_uuid}`}
                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    >
                                      <i className='bi bi-cash-stack fs-3' title='Rent info'></i>
                                    </Link> */}
                                    {/* {property.property_account_status === 2 ? (
                                      <button
                                        onClick={() => handleUnBlock(property.property_uuid)}
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      >
                                        <i className='bi bi-check-square fs-3' title='Unblock'></i>
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() => handleBlock(property.property_uuid)}
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                      >
                                        <i className='bi bi-x-square fs-3' title='Block'></i>
                                      </button>
                                    )} */}
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                        )}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                </div>
              </div>
            </div>
            {/* End: Table */}
            {/* Begin: Pagination */}
            {/* {
              propertyData && pageCount>1 && <PaginationComponent itemsPerPage={itemsPerPage} dataLength={dataLength} setItemOffset={setItemOffset} currentPage={currentPage} setCurrentPage={setCurrentPage}
              pageCount = {pageCount}/>
            } */}
            {/* End: Pagination */}
          </div>

          {
              propertyData && pageCount>1 && <PaginationComponent itemsPerPage={itemsPerPage} dataLength={dataLength} setItemOffset={setItemOffset} currentPage={currentPage} setCurrentPage={setCurrentPage}
              pageCount = {pageCount}/>
            }
        </div>
        // {/* End: property page content */}
      )}
    </>
    
    
  
}

export default SuperAdminPropertyHome
